( function ( $ ) {
  class menuScroll {

    /**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {
      // Initialize the events.
			const body = document.body;
      const scrollUp = "scroll-up";
      const scrollDown = "scroll-down";
      let lastScroll = 0;
      this.addEvents( body, scrollUp, scrollDown, lastScroll );
    }
    
    /**
     * Add Event. 
     *  
     * @return {void}
      */
    addEvents( body, scrollUp, scrollDown, lastScroll ) {

      window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll <= 0) {
          body.classList.remove(scrollUp);
          return;
        }
      
        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
          // down
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);
        } else if (
          currentScroll < lastScroll &&
          body.classList.contains(scrollDown)
        ) {
          // up
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
      });
    }
  }

  $( document ).ready( function() {

    new menuScroll();
  
  } );

} )( jQuery );
